import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { companyInfo } from "../../data/mockData";
import { Phone, Mail, MapPin, Clock, ArrowRight, ArrowUpRight } from "lucide-react";
import axios from "axios";
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const Footer = () => {
  const [s, setS] = useState({});
  useEffect(() => { axios.get(`${API}/settings`).then(r => setS(r.data)).catch(() => {}); }, []);
  const phone = s.phone || companyInfo.phone;
  const email = s.email || companyInfo.email;
  const city = s.city || companyInfo.address.city;
  const street = s.street || companyInfo.address.street;
  const zip = s.zip_code || companyInfo.address.zip;
  const emergency = s.emergency_phone || companyInfo.emergency;

  return (
    <footer role="contentinfo">
      {/* Pre-footer CTA */}
      <div className="bg-[#63b32e]">
        <div className="max-w-[1300px] mx-auto px-6 py-12 flex flex-col md:flex-row items-center justify-between gap-6">
          <div>
            <h3 className="text-xl font-bold text-white mb-1" style={{ fontFamily: "var(--serif)" }}>Bereit für Ihr Projekt?</h3>
            <p className="text-white/60 text-sm">Kontaktieren Sie uns für eine unverbindliche Beratung.</p>
          </div>
          <div className="flex items-center gap-3">
            <Link to="/kontakt" className="group inline-flex items-center gap-2 bg-white text-[#63b32e] font-bold px-7 py-3 rounded-full text-[15px] hover:bg-[#f0fdf4] transition-colors">
              Kontakt aufnehmen <ArrowRight size={15} className="group-hover:translate-x-0.5 transition-transform" />
            </Link>
            <a href={`tel:${phone.replace(/\s/g,"")}`} className="inline-flex items-center gap-2 border border-white/30 text-white font-semibold px-7 py-3 rounded-full text-[15px] hover:bg-white/10 transition-colors">
              <Phone size={15} /> Anrufen
            </a>
          </div>
        </div>
      </div>

      {/* Main footer – light background */}
      <div className="bg-[#f5f7f5] border-t border-[#e5e8e5]">
        <div className="max-w-[1300px] mx-auto px-6 py-16">
          {/* Top: Logo + Notdienst */}
          <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center gap-6 mb-12 pb-10 border-b border-[#dde0dd]">
            <div className="flex items-center gap-6">
              <img src={companyInfo.logo} alt="Hoffmann" className="h-11 w-auto" />
              <div className="w-px h-12 bg-[#ccc]" />
              <img src={companyInfo.plusInstallateurLogo} alt="Buderus System Partner" className="h-24 w-auto" />
            </div>
            <div className="flex items-center gap-5">
              <div className="text-right hidden sm:block">
                <div className="text-[#555] text-[12px] font-bold uppercase tracking-wider">Notrufdienst</div>
                <div className="text-[#999] text-[11px]">Mo–Fr 16:30–19 · Sa & So 10–18</div>
              </div>
              <a href={`tel:${emergency.replace(/\s/g,"")}`}
                className="inline-flex items-center gap-2 bg-[#ffef38] text-[#333] font-bold px-6 py-2.5 rounded-full text-[13px] hover:bg-[#e6d832] transition-colors shadow-sm">
                <Phone size={13} />{emergency}
              </a>
            </div>
          </div>

          {/* Links */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-10">
            <div>
              <h4 className="text-[12px] font-bold tracking-[0.15em] uppercase text-[#1a1a1a] mb-4">Leistungen</h4>
              <div className="space-y-2.5">
                {[
                  { to: "/heizung", l: "Heizung & Wärme" },
                  { to: "/bad-sanitaer", l: "Bad & Sanitär" },
                  { to: "/regenerative-energien", l: "Regenerative Energien" },
                  { to: "/smart-home", l: "Smart Home" },
                  { to: "/klima", l: "Klima & Lüftung" },
                  { to: "/heizungsrechner", l: "Heizungsrechner" },
                ].map(x => <Link key={x.to} to={x.to} className="block text-[#666] text-[14px] hover:text-[#63b32e] transition-colors">{x.l}</Link>)}
              </div>
            </div>
            <div>
              <h4 className="text-[12px] font-bold tracking-[0.15em] uppercase text-[#1a1a1a] mb-4">Unternehmen</h4>
              <div className="space-y-2.5">
                <Link to="/karriere" className="block text-[#666] text-[14px] hover:text-[#63b32e] transition-colors">Karriere</Link>
                <Link to="/kontakt" className="block text-[#666] text-[14px] hover:text-[#63b32e] transition-colors">Kontakt</Link>
              </div>
            </div>
            <div>
              <h4 className="text-[12px] font-bold tracking-[0.15em] uppercase text-[#1a1a1a] mb-4">Rechtliches</h4>
              <div className="space-y-2.5">
                <Link to="/impressum" className="block text-[#666] text-[14px] hover:text-[#63b32e] transition-colors">Impressum</Link>
                <Link to="/datenschutz" className="block text-[#666] text-[14px] hover:text-[#63b32e] transition-colors">Datenschutzerklärung</Link>
              </div>
            </div>
            <div>
              <h4 className="text-[12px] font-bold tracking-[0.15em] uppercase text-[#1a1a1a] mb-4">Kontakt</h4>
              <div className="space-y-3 text-[14px]">
                <div className="flex items-start gap-2.5 text-[#666]"><MapPin size={15} className="text-[#63b32e] mt-0.5 shrink-0" />{street}, {zip} {city}</div>
                <a href={`tel:${phone.replace(/\s/g,"")}`} className="flex items-center gap-2.5 text-[#666] hover:text-[#63b32e] transition-colors"><Phone size={15} className="text-[#63b32e] shrink-0" />{phone}</a>
                <a href={`mailto:${email}`} className="flex items-center gap-2.5 text-[#666] hover:text-[#63b32e] transition-colors"><Mail size={15} className="text-[#63b32e] shrink-0" />{email}</a>
                <div className="flex items-start gap-2.5 text-[#666]"><Clock size={15} className="text-[#63b32e] shrink-0 mt-0.5" /><div className="text-sm"><p>Mo–Fr: 07:30 – 12:00</p><p>Mo–Do: 13:30 – 16:00</p></div></div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-[#dde0dd]">
          <div className="max-w-[1300px] mx-auto px-6 py-5 flex flex-col md:flex-row justify-between items-center gap-3">
            <p className="text-[#999] text-[13px]">© {new Date().getFullYear()} {s.company_name || companyInfo.name}. Alle Rechte vorbehalten.</p>
            <a href="https://hetrexstudios.de" target="_blank" rel="noopener noreferrer" className="text-[#999] text-[13px] hover:text-[#666] transition-colors flex items-center gap-1">
              Design by Hetrex Studios <ArrowUpRight size={10} />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};
export default Footer;
